/* Minimal chat-message renderer:
   - Strips **bold** markers (renders inner text as regular)
   - Turns http(s):// URLs into clickable hyperlinks
   - Preserves whitespace / newlines
   No other markdown is rendered. */
import React from 'react';

const URL_RE = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?])/g;

function renderInline(text) {
  // First split on URLs
  const parts = [];
  let last = 0;
  let m;
  while ((m = URL_RE.exec(text)) !== null) {
    if (m.index > last) parts.push({ type: 't', v: text.slice(last, m.index) });
    parts.push({ type: 'a', v: m[0] });
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push({ type: 't', v: text.slice(last) });

  // Second pass — strip **...** from text parts
  return parts.map((p, i) => {
    if (p.type === 'a') {
      return (
        <a key={i} href={p.v} target="_blank" rel="noopener noreferrer"
           className="text-amber-300 underline decoration-amber-400/40 hover:decoration-amber-300 break-all">
          {p.v}
        </a>
      );
    }
    // Strip **bold** markers → keep inner text plain
    const stripped = p.v.replace(/\*\*(.*?)\*\*/gs, '$1').replace(/\*\*/g, '');
    return <React.Fragment key={i}>{stripped}</React.Fragment>;
  });
}

export function RichText({ text, className }) {
  const lines = String(text || '').split('\n');
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {renderInline(line)}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
}
